import React,{Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import WOW from 'wowjs';	
import CountUp from 'react-countup';
import SimpleReactLightbox,{SRLWrapper} from 'simple-react-lightbox';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
import PageTitle from './../../Layout/PageTitle';
import SponsorOwl from './SponsorOwl';
import {VideoPopup2} from './../../Element/VideoPopup';
import image1 from './../../../images/about/All towers.png';
import Bnr1 from './../../../images/banner/banner2.jpeg';
import banner1 from './../../../images/main-slider/1.jpeg';
import achievementsBg from './../../../images/main-slider/slider4.jpeg';
import banner3 from './../../../images/banner/banner1.png';
import banner4 from './../../../images/banner/bnr3.jpg';
import ban1 from './../../../images/banner/ban1.jpeg';
import banner from './../../../images/banner/banner.jpeg';
import abBrandBg from './../../../images/main-slider/ab.png';
import certificateTrophy from './../../../images/certificate.jpeg';
import certificateEng from './../../../images/certificateeng.png';
import certificateArabic from './../../../images/certificatearabic.png';
// Portfolio images from Index2
import port1 from './../../../images/portfolio/portfolio-box/pic1.jpg';
import port2 from './../../../images/portfolio/portfolio-box/pic2.jpg';
import port3 from './../../../images/portfolio/portfolio-box/pic3.jpg';
import port4 from './../../../images/portfolio/portfolio-box/pic4.jpg';
import port5 from './../../../images/portfolio/portfolio-box/pic5.jpg';

import team1 from './../../../images/team/our-team/pic1.jpg';
import team2 from './../../../images/team/our-team/pic2.jpg';
import team3 from './../../../images/team/our-team/pic3.jpg';
import team4 from './../../../images/team/our-team/pic4.jpg';

const aboutBlog = [
	{
		icon: <i className="ti-rocket" />, 
		title: 'Safety',
		description: 'Proactive safety planning helps us provide a safe working environment for everyone working on the project, people visiting the job site or working.'
	},	
	{
		icon: <i className="ti-pie-chart" />, 
		title: 'Teamwork',
		description: 'To become an industry leader, it is important for us to encourage team work in order to solve any construction challenges and to achieve results.'
	},	
	{
		icon: <i className="ti-ruler-pencil" />, 
		title: 'Integrity',
		description: 'Our partnership with our clients is based on mutual trust and we do what is best for our clients following our company\'s values and methods.'
	},	

];

// eslint-disable-next-line no-unused-vars -- Building Construction Progress section was removed
const progessBlog = [];

const counterBlog = [
	{icon: <i className="ti-home" />, num: '3587',  title: 'Satisfied Clients',},	
	{icon: <i className="ti-user" />, num: '70',    title: 'Employees',},	
	{icon: <i className="ti-medall-alt" />, num: '685',   title: 'Cups of Coffee',},	
	{icon: <i className="ti-truck" />, num: '21930', title: 'Lines of Code',},	
];

const teamBlog= [
	{image: team1, },
	{image: team2, },
	{image: team3, },
	{image: team4, },
];

class Aboutus2 extends Component{
	componentDidMount(){
		new WOW.WOW().init();	
	}
	render(){
	
		return(
			<Fragment>
				<Header />
				<div className="page-content bg-white page-about-us">
					<PageTitle motherMenu="About us " activeMenu="About Us" />
					
					{/* About Company Section */}
					<section
						className="content-inner"
						style={{
							padding: '80px 0',
							paddingBottom: '0px',
						}}
						data-content=""
					>
						<div className="container">
							<div className="row align-items-center">
								{/* Left Section - Images Collage */}
								<div className="col-lg-6 col-md-6 mb-4 mb-md-0">
									<div style={{ position: 'relative', paddingBottom: '80px' }}>
										{/* Top Image */}
										<div
											style={{
												position: 'relative',
												width: '100%',
												zIndex: 1,
											}}
										>
											<img
												src={image1}
												alt="Cityscape"
												style={{
													width: '100%',
													height: '480px',
													objectFit: 'cover',
													borderRadius: '10px',
													boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
												}}
											/>
										</div>
										{/* Bottom Image - Overlapping */}
										<div
											style={{
												position: 'absolute',
												bottom: '0',
												left: '20px',
												width: '55%',
												zIndex: 2,
											}}
										>
											{/* <img 
												src={banner3} 
												alt="Goldcrest Executive" 
												style={{
													width: '100%',
													height: '171px',
													objectFit: 'cover',
													borderRadius: '10px',
													boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
												}}
											/> */}
										</div>
									</div>
								</div>

								{/* Right Section - Text Content */}
								<div className="col-lg-6 col-md-6">
									<div className="section-head" style={{ paddingLeft: '20px' }}>
										<span className="about-heading-eyebrow">Our Story</span>
										<h2 className="title about-uniform-title">About</h2>
										<div className="about-goldcrest-title-rule" aria-hidden="true" />
										<p
											style={{
												marginTop: '20px',
												fontSize: '16px',
												lineHeight: '1.8',
												color: '#333',
												marginBottom: '0',
											}}
										>
											Star Giga Establishment Limited is a UAE based community development company renowned for its development of landmark freehold properties in UAE. The company's project portfolio includes Goldcrest Views 1 and 2, Goldcrest Executive in Jumeira Lake Towers, Dubai and Goldcrest Dreams Tower A and Tower B located in Emirates City Ajman.
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* About Company Section End */}

					{/* Mission & vision — full-width bg (ab.png) */}
					<section className="about-goldcrest-brand">
						<div
							className="about-goldcrest-brand__bg"
							style={{ backgroundImage: `url(${abBrandBg})` }}
							aria-hidden="true"
						/>
						<div className="about-goldcrest-brand__wash" aria-hidden="true" />
						<div className="container about-goldcrest-brand__inner">
							<div className="row align-items-center">
								<div className="col-lg-6 mb-5 mb-lg-0 wow fadeInUp" data-wow-duration="0.9s" data-wow-delay="0.1s">
									<div className="about-goldcrest-copy">
										<ul className="about-goldcrest-points">
											<li>
												<p>
													Communication, commitment, and client care are core values that permeate every activity we
													conduct. We provide full, holistic real estate assistance by actively listening and
													translating each client&apos;s priorities into practical outcomes.
												</p>
											</li>
											<li>
												<p>
													By understanding our clients&apos; needs in depth, we consistently deliver high-quality
													results that maximize long-term value for their real estate investments, both at home and
													abroad.
												</p>
											</li>
										</ul>
									</div>
								</div>
								<div className="col-lg-6 wow fadeInUp" data-wow-duration="0.9s" data-wow-delay="0.2s">
									<div className="about-goldcrest-heading-wrap">
										<div className="about-goldcrest-heading-accent" aria-hidden="true">
											<span className="about-goldcrest-heading-accent__bar" />
											<span className="about-goldcrest-heading-accent__caret" />
										</div>
										<div>
											{/* <span className="about-goldcrest-mission-eyebrow">Mission &amp; vision</span> */}
											<p className="about-goldcrest-commitment-eyebrow">Our commitment</p>
											<h2 className="about-goldcrest-display-title title">Our Promise and Values</h2>
											<div className="about-goldcrest-title-rule" aria-hidden="true" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* Mission & vision End */}

					{/* Editorial — project spotlight */}
					<section className="about-promise-editorial">
						<div className="container">
							<div className="row justify-content-center">
								<div className="col-xl-9 col-lg-10 about-promise-editorial__inner wow fadeInUp" data-wow-duration="0.9s" data-wow-delay="0.08s">
									<div className="about-goldcrest-heading-wrap">
										<div className="about-goldcrest-heading-accent" aria-hidden="true">
											<span className="about-goldcrest-heading-accent__bar" />
											<span className="about-goldcrest-heading-accent__caret" />
										</div>
										<div>
											<p className="about-goldcrest-commitment-eyebrow">Project delivered</p>
											<h2 className="about-goldcrest-display-title title">Goldcrest Executive</h2>
											<div className="about-goldcrest-title-rule" aria-hidden="true" />
										</div>
									</div>
									<div className="about-promise-editorial__body">
										<p>
											40-floor tower in the Jumeirah Lake Towers in Dubai, United Arab Emirates. The tower has a total
											structural height of 165 m (541 ft). Construction of the Goldcrest Executive was completed in
											2008.
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* Editorial project spotlight End */}

					{/* Our Achievements Section */}
					<section
						style={{
							position: 'relative',
							backgroundImage: `url(${achievementsBg})`,
							backgroundSize: 'cover',
							backgroundPosition: 'top',
							backgroundAttachment: 'fixed',
							padding: '250px 0px',
							minHeight: '100%',
						}}
					>
						<div className="container">
							<div className="row justify-content-center">
								<div className="col-lg-10 col-md-12">
									<div
										style={{
											backgroundColor: 'rgba(0, 0, 0, 0.37)',
											backdropFilter: 'blur(6px)',
											WebkitBackdropFilter: 'blur(14px)',
											padding: '60px 50px',
											borderRadius: '15px',
											boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
											textAlign: 'center',
											border: '1px solid rgba(255, 255, 255, 0.08)',
										}}
									>
										<span className="about-heading-eyebrow about-heading-eyebrow--light">Milestones</span>
										<h2 className="about-uniform-title about-uniform-title--light">Our Achievements</h2>
										<div className="about-goldcrest-title-rule about-separator-centered" aria-hidden="true" />
										<p
											style={{
												fontSize: '18px',
												lineHeight: '1.8',
												color: 'white',
												marginBottom: '0',
												fontFamily: 'serif',
											}}
										>
											The <strong style={{ color: 'white' }}>Goldcrest Views Tower</strong> at JLT, Dubai won Best Developer award of cityscape for design and quality in residential building category Cityscape Middle East Award.
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* Our Achievements Section End */}

					{/* Appreciation Section */}
					<section className="about-appreciation-section">
						<div className="container">
							<div className="row align-items-center about-appreciation-intro">
								<div className="col-lg-6 mb-4 mb-lg-0 wow fadeInUp" data-wow-duration="0.9s" data-wow-delay="0.12s">
									<div className="about-appreciation-copy">
										<span className="about-heading-eyebrow">Recognition</span>
										<h2 className="title about-uniform-title">Appreciation</h2>
										<div className="about-goldcrest-title-rule" aria-hidden="true" />
										<p className="about-appreciation-kicker">Certificate of Appreciation</p>
										<p className="about-appreciation-lead">
											To Express Gratitude And Deep Appreciation
										</p>
										<p className="about-appreciation-recipient">
											Is Given to <strong>Star Giga Establishment</strong>
										</p>
										<p>
											In Recognition Of Excellence, Your High Commitment And Your Professional
											Efforts That Led To The Success Of All Business.
										</p>
										<p className="about-appreciation-year">For The Year 2022</p>
									</div>
								</div>
								<div className="col-lg-6 wow fadeInUp" data-wow-duration="0.9s" data-wow-delay="0.2s">
									<div className="about-appreciation-trophy">
										<img
											src={certificateTrophy}
											alt="Star Giga Establishment Certificate of Appreciation trophy"
										/>
									</div>
								</div>
							</div>

							<div className="row about-appreciation-certs">
								<div className="col-md-6 mb-4 mb-md-0 wow fadeInUp" data-wow-duration="0.9s" data-wow-delay="0.15s">
									<h3 className="about-appreciation-cert-heading">Certificate Of Appreciation Arabic</h3>
									<div className="about-appreciation-cert">
										<img
											src={certificateArabic}
											alt="Certificate of Appreciation — Arabic"
										/>
									</div>
								</div>
								<div className="col-md-6 wow fadeInUp" data-wow-duration="0.9s" data-wow-delay="0.25s">
									<h3 className="about-appreciation-cert-heading">English Translation</h3>
									<div className="about-appreciation-cert">
										<img
											src={certificateEng}
											alt="Certificate of Appreciation — English Translation"
										/>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* Appreciation Section End */}

					{/* About Us Start */}
				
					{/* About Us End */}
					
					{/* Video Section  */}
					{/* <VideoSection />	 */}
					{/* Video Section  End*/}
					
					{/* Our Gallery */}
					{/* <div className="content-inner-2">
						<div className="container">
							<SimpleReactLightbox>
								<SRLWrapper>
									<div className="row our-gallery">
										<div className="col-lg-6 col-md-6 col-sm-6 m-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
											<img src={banner1} alt="" style={{width: '100%', height: '350px', objectFit: 'cover', borderRadius: '10px'}} />
										</div>
										<div className="col-lg-6 col-md-6 col-sm-6 m-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
											<img src={banner2} alt="" style={{width: '100%', height: '350px', objectFit: 'cover', borderRadius: '10px'}} />
										</div>
										<div className="col-lg-6 col-md-6 col-sm-6 m-sm-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.6s">
											<img src={ban1} alt="" style={{width: '100%', height: '350px', objectFit: 'cover', borderRadius: '10px'}} />
										</div>
										<div className="col-lg-6 col-md-6 col-sm-6 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.8s">
											<img src={banner} alt="" style={{width: '100%', height: '350px', objectFit: 'cover', borderRadius: '10px'}} />
										</div>
									</div>
								</SRLWrapper>	
							</SimpleReactLightbox>	
						</div>
					</div> */}
					{/* Our Gallery  End */}
					
					{/* Our Team  */}
					{/* <TeamSection /> */}
					{/* Our Team End */}
					
					{/* Our Partners */}
					{/* <SpondorSection /> */}
					{/* Our Partners End*/ }
				</div>
				<style>{`
					.page-about-us .about-heading-eyebrow {
						display: inline-block;
						font-size: 11px;
						font-weight: 600;
						letter-spacing: 0.28em;
						text-transform: uppercase;
						color: #b8975f;
						margin-bottom: 12px;
					}
					.page-about-us .about-heading-eyebrow--light {
						color: #d6bc84;
					}
					.page-about-us .about-uniform-title {
						font-size: clamp(34px, 4.1vw, 52px);
						line-height: 1.12;
						font-weight: 700;
						letter-spacing: -0.02em;
						color: #1a1a1a;
						margin-bottom: 16px;
						text-transform: uppercase;
					}
					.page-about-us .about-uniform-title--light {
						color: #fff;
					}
					.page-about-us .about-separator-centered {
						margin-left: auto;
						margin-right: auto;
						margin-bottom: 24px;
					}
					.about-promise-editorial {
						position: relative;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: stretch;
						// min-height: min(100vh, 920px);
						padding: 72px 0;
						background: #ffffff;
						overflow: hidden;
					}
					.about-promise-editorial__inner {
						display: flex;
						flex-direction: column;
						align-items: center;
						text-align: center;
					}
					.about-promise-editorial__inner .about-goldcrest-heading-wrap {
						flex-direction: column;
						align-items: center;
						justify-content: center;
						gap: 0;
					}
					.about-promise-editorial__inner .about-goldcrest-heading-wrap > div {
						width: 100%;
						text-align: center;
					}
					.about-promise-editorial__inner .about-goldcrest-display-title {
						text-align: center;
					}
					.about-promise-editorial__inner .about-goldcrest-commitment-eyebrow {
						margin-left: auto;
						margin-right: auto;
						text-transform: uppercase;
						letter-spacing: 0.28em;
					}
					.about-promise-editorial__inner .about-goldcrest-title-rule {
						margin-left: auto;
						margin-right: auto;
					}
					.about-promise-editorial__body {
						max-width: 640px;
						width: 100%;
						margin-top: 40px;
						margin-left: auto;
						margin-right: auto;
					}
					.about-promise-editorial__body p {
						font-size: 17px;
						line-height: 1.88;
						color: #4a4a4a;
						text-align: center;
						margin: 0 0 1.35rem;
					}
					.about-promise-editorial__body p:last-child {
						margin-bottom: 0;
					}
					@media (max-width: 991.98px) {
						.about-promise-editorial {
							min-height: min(100vh, 840px);
							padding: 64px 0;
						}
					}
					@media (max-width: 575.98px) {
						.about-promise-editorial {
							min-height: 0;
							padding: 56px 0 64px;
						}
						.about-promise-editorial__body p {
							font-size: 16px;
							line-height: 1.82;
						}
					}
					.about-goldcrest-brand {
						position: relative;
						overflow: hidden;
						padding: 96px 0 200px;
						background: linear-gradient(175deg, #faf8f5 0%, #f0ebe4 48%, #ebe6df 100%);
					}
					.about-goldcrest-brand__bg {
						position: absolute;
						inset: 0;
						background-repeat: no-repeat;
						background-position: right center;
						background-size: cover;
						z-index: 0;
					}
					.about-goldcrest-brand__wash {
						position: absolute;
						inset: 0;
						z-index: 1;
						background: linear-gradient(
							105deg,
							rgba(250, 248, 245, 0.97) 0%,
							rgba(250, 248, 245, 0.82) 38%,
							rgba(250, 248, 245, 0.35) 62%,
							rgba(250, 248, 245, 0.08) 100%
						);
						pointer-events: none;
					}
					.about-goldcrest-brand__inner {
						position: relative;
						z-index: 2;
					}
					.about-goldcrest-points {
						list-style: none;
						margin: 0;
						padding: 0 0 0 22px;
						border-left: 3px solid #b8975f;
					}
					.about-goldcrest-points li {
						position: relative;
						padding-left: 22px;
						margin-bottom: 1.75rem;
					}
					.about-goldcrest-points li:last-child {
						margin-bottom: 0;
					}
					.about-goldcrest-points li::before {
						content: "";
						position: absolute;
						left: -13px;
						top: 0.55em;
						width: 0;
						height: 0;
						border-style: solid;
						border-width: 7px 0 7px 12px;
						border-color: transparent transparent transparent #b8975f;
					}
					.about-goldcrest-points p {
						font-size: 17px;
						line-height: 1.85;
						color: #4a4a4a;
						margin: 0;
					}
					.about-goldcrest-points strong {
						font-weight: 600;
						color: #1a1a1a;
					}
					.about-goldcrest-heading-wrap {
						display: flex;
						align-items: flex-start;
						gap: 18px;
					}
					.about-goldcrest-heading-accent {
						display: none;
						flex-direction: column;
						align-items: center;
						flex-shrink: 0;
						padding-top: 6px;
					}
					.about-goldcrest-heading-accent__bar {
						display: block;
						width: 3px;
						height: 52px;
						background: linear-gradient(180deg, #b8975f, #d4bc7f);
						border-radius: 2px;
					}
					.about-goldcrest-heading-accent__caret {
						display: block;
						width: 0;
						height: 0;
						margin-top: 8px;
						margin-left: -3px;
						border-style: solid;
						border-width: 7px 0 7px 11px;
						border-color: transparent transparent transparent #b8975f;
					}
					.about-goldcrest-display-title {
						font-size: 50px;
						line-height: 1.12;
						font-weight: 700;
						margin: 0 0 0;
						letter-spacing: -0.02em;
						text-transform: none;
						color: #1a1a1a;
					}
					.about-goldcrest-mission-eyebrow {
						display: inline-block;
						font-size: 11px;
						font-weight: 600;
						letter-spacing: 0.28em;
						text-transform: uppercase;
						color: #b8975f;
						margin-bottom: 10px;
					}
					.about-goldcrest-commitment-eyebrow {
						font-size: 11px;
						font-weight: 600;
						letter-spacing: 0.32em;
						text-transform: uppercase;
						color: #9a7d4a;
						margin: 0 0 16px;
						line-height: 1.5;
					}
					.about-goldcrest-title-rule {
						width: 72px;
						height: 3px;
						background: linear-gradient(90deg, #b8975f, #d4bc7f);
						border-radius: 2px;
						margin-top: 18px;
					}
					@media (max-width: 991.98px) {
						.about-goldcrest-brand {
							padding: 72px 0 68px;
						}
						.about-goldcrest-brand__bg {
							background-position: 70% center;
						}
						.about-goldcrest-brand__wash {
							background: linear-gradient(
								180deg,
								rgba(250, 248, 245, 0.96) 0%,
								rgba(250, 248, 245, 0.88) 45%,
								rgba(250, 248, 245, 0.55) 100%
							);
						}
					}
					@media (max-width: 575.98px) {
						.about-goldcrest-heading-wrap {
							gap: 14px;
						}
						.about-goldcrest-heading-accent__bar {
							height: 40px;
						}
						.about-goldcrest-points p {
							font-size: 16px;
							line-height: 1.8;
						}
					}
					.about-appreciation-section {
						padding: 88px 0 96px;
						background: #ffffff;
					}
					.about-appreciation-intro {
						margin-bottom: 56px;
					}
					.about-appreciation-copy .about-goldcrest-title-rule {
						margin-bottom: 28px;
					}
					.about-appreciation-copy p {
						font-size: 17px;
						line-height: 1.85;
						color: #4a4a4a;
						margin: 0 0 1.1rem;
					}
					.about-appreciation-kicker {
						font-size: 13px !important;
						font-weight: 600;
						letter-spacing: 0.22em;
						text-transform: uppercase;
						color: #b8975f !important;
						margin-top: 0 !important;
						margin-bottom: 14px !important;
					}
					.about-appreciation-lead {
						font-size: 22px !important;
						line-height: 1.45 !important;
						font-weight: 600;
						color: #1a1a1a !important;
						margin-bottom: 18px !important;
					}
					.about-appreciation-recipient {
						font-size: 18px !important;
						color: #1a1a1a !important;
					}
					.about-appreciation-recipient strong {
						font-weight: 700;
						color: #1a1a1a;
					}
					.about-appreciation-year {
						font-size: 15px !important;
						font-weight: 600;
						letter-spacing: 0.12em;
						text-transform: uppercase;
						color: #9a7d4a !important;
						margin-top: 8px !important;
						margin-bottom: 0 !important;
					}
					.about-appreciation-trophy {
						display: flex;
						align-items: center;
						justify-content: center;
						padding: 12px 8px;
					}
					.about-appreciation-trophy img {
						width: 100%;
						max-width: 420px;
						height: auto;
						object-fit: contain;
						border-radius: 10px;
						box-shadow: 0 12px 32px rgba(34, 30, 22, 0.12);
					}
					.about-appreciation-cert-heading {
						font-size: 30px;
						font-weight: 700;
						color: #1a1a1a;
						text-align: center;
						margin: 0 0 16px;
						letter-spacing: 0.01em;
					}
					.about-appreciation-cert {
						height: auto;
						padding: 12px;
						background: #faf8f5;
						border: 1px solid rgba(184, 151, 95, 0.18);
						border-radius: 12px;
						box-shadow: 0 10px 28px rgba(34, 30, 22, 0.06);
					}
					.about-appreciation-cert img {
						display: block;
						width: 100%;
						height: auto;
						border-radius: 6px;
					}
					@media (max-width: 991.98px) {
						.about-appreciation-section {
							padding: 72px 0 80px;
						}
						.about-appreciation-intro {
							margin-bottom: 40px;
						}
						.about-appreciation-lead {
							font-size: 20px !important;
						}
					}
					@media (max-width: 575.98px) {
						.about-appreciation-section {
							padding: 56px 0 64px;
						}
						.about-appreciation-copy p {
							font-size: 16px;
							line-height: 1.8;
						}
						.about-appreciation-cert {
							padding: 8px;
						}
					}
					.about-values-section {
						padding: 88px 0;
						background: linear-gradient(145deg, #f8f6f1 0%, #f0ece2 100%);
					}
					.about-values-shell {
						background: rgba(255, 255, 255, 0.74);
						border: 1px solid rgba(184, 151, 95, 0.2);
						border-radius: 22px;
						padding: 56px 52px;
						box-shadow: 0 18px 40px rgba(34, 30, 22, 0.08);
						backdrop-filter: blur(2px);
					}
					.about-values-head {
						display: flex;
						align-items: center;
						gap: 26px;
						margin-bottom: 36px;
					}
					.about-values-card {
						height: 100%;
						padding: 30px 28px;
						border-radius: 16px;
						background-color: #fff;
						border: 1px solid rgba(0, 0, 0, 0.06);
						box-shadow: 0 10px 22px rgba(0, 0, 0, 0.05);
						transition: transform 0.25s ease, box-shadow 0.25s ease;
					}
					.about-values-card:hover {
						transform: translateY(-4px);
						box-shadow: 0 14px 28px rgba(0, 0, 0, 0.08);
					}
					.about-values-card p {
						font-size: 17px;
						line-height: 1.9;
						color: #343434;
						margin: 0;
					}
					@media (max-width: 991.98px) {
						.about-values-section {
							padding: 70px 0;
						}
						.about-values-shell {
							padding: 40px 28px;
						}
						.about-values-head {
							gap: 18px;
							margin-bottom: 28px;
						}
						.about-values-card p {
							font-size: 16px;
							line-height: 1.8;
						}
					}
					@media (max-width: 575.98px) {
						.about-values-shell {
							padding: 32px 20px;
							border-radius: 16px;
						}
						.about-values-head {
							flex-direction: column;
							align-items: flex-start;
							gap: 14px;
						}
						.about-values-card {
							padding: 24px 20px;
						}
					}
				`}</style>
				<FooterPremium />
			</Fragment>
		)
	}
}


function VideoSection(){
	return(
		<>
			<section className="video-bx overlay-black-middle" style={{backgroundImage: "url(" + Bnr1 + ")", backgroundSize: "cover"}}>
				<div className="container">
					<div className="row">
						<div className="col-lg-12 text-center text-white">
							<div className="video-play">
								
								<VideoPopup2/>
							</div>
							<h2 className="video-title text-white">Intro Video</h2>
							<p className="video-content">Experience the essence of Goldcrest Dreams, Ajman in this captivating introduction video.</p>
							<Link to={"/contact-us"} className="btn btn-primary radius-xl"><span className="text-black">Contact us</span></Link>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

function CounterSection(){
	return(
		<>
			<div className="bg-light content-inner" data-content="OUR TEAM">
				<div className="container">
					<div className="row">
						{counterBlog.map((data,index)=>(
							<div className="col-lg-3 col-md-6 col-sm-6 col-6 m-b30" key={index}>
								<div className="counter-left archia-counter">
									<div className="icon-lg pull-left m-tb10">{data.icon}</div>
									<div className="clearfix m-l90">
										<div className="counter m-b5"><CountUp end={data.num} duration={4}/> </div>
										<span className="font-16 text-black">{data.title}</span> 
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	)
}

function TeamSection(){
	return(
		<>
			<section className="content-inner-2" data-content="OUR TEAM">
				<div className="container">
					<div className="section-head text-center">
						<p>Meet The Team</p>
						<h2 className="title">Our Team</h2>
					</div>
					<div className="row">
						{teamBlog.map((data,index)=>(
							<div className="col-lg-3 col-md-6 col-sm-6 m-md-b30 wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s" key={index}>
								<div className="our-team team-style1">
									<div className="dlab-media radius-sm">
										<img src={data.image} alt="" />
									</div>
									<div className="team-title-bx text-center">
										<h2 className="team-title">Philip Demarco</h2>
										<span className="clearfix">founder of agency</span>
									</div>
								</div>
							</div>
						))}	
					</div>
				</div>
			</section>
		</>
	)
}

function SpondorSection(){
	return(
		<>
			<section className="content-inner-1" data-content="SOPONSER">
				<div className="container">
					<div className="section-head text-center">
						<p>Explore Soponser</p>
						<h2 className="title">Explore Sponsor</h2>
					</div>
					<SponsorOwl />
				</div>	
			</section>	
		</>
	)
}


export { VideoSection, CounterSection ,TeamSection, SpondorSection}

export default Aboutus2;
				